import React from 'react';

import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { Stories } from 'apps/auth/components/common/Layout/Stories/Stories';
import BasePage from 'apps/auth/components/utils/BasePage';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const LibreDisclaimers = (props) => {
    const {
        notNowButton,
        tryPaysendLibreButton,
        libreDisclaimerTitle,
        libreDisclaimerTitle1,
        libreDisclaimerTitle2,
        libreDisclaimerTitle3,
        libreDisclaimerTitlePurple,
    } = usePageMessages();

    const { libreDisclaimerText, libreDisclaimerText1, libreDisclaimerText2, libreDisclaimerText3 } = useExtra();

    const getTexts = (textArr) => {
        if (textArr) {
            return textArr.map((text, i) => <p key={'libre' + i}>{text}</p>);
        }
        return null;
    };

    const steps = [
        <InfoPage
            key="step-1"
            iconName="cardp-mastercard-thin"
            iconColor="primary"
            headerText={
                <>
                    <span>{libreDisclaimerTitlePurple}</span>
                    {libreDisclaimerTitle}
                </>
            }
            secondaryText={libreDisclaimerText}
            primaryButtonCaption={tryPaysendLibreButton}
            primaryButtonType="button"
            primaryButtonOnClick={props.primaryButtonOnClick}
            topButtonCaption={notNowButton}
            topButtonType={props.backUrl ? 'link' : 'button'}
            topButtonLink={props.backUrl}
            topButtonOnClick={props.topButtonOnClick}
            insideModalComponent
            insideStories
        />,
        <InfoPage
            key="step-2"
            iconName="1-thin"
            iconColor="primary"
            headerText={libreDisclaimerTitle1}
            secondaryText={<>{getTexts(libreDisclaimerText1)}</>}
            primaryButtonCaption={tryPaysendLibreButton}
            primaryButtonType="button"
            primaryButtonOnClick={props.primaryButtonOnClick}
            topButtonCaption={notNowButton}
            topButtonType={props.backUrl ? 'link' : 'button'}
            topButtonLink={props.backUrl}
            topButtonOnClick={props.topButtonOnClick}
            insideModalComponent
            insideStories
        />,
        <InfoPage
            key="step-3"
            iconName="2-thin"
            iconColor="primary"
            headerText={libreDisclaimerTitle2}
            secondaryText={<>{getTexts(libreDisclaimerText2)}</>}
            primaryButtonCaption={tryPaysendLibreButton}
            primaryButtonType="button"
            primaryButtonOnClick={props.primaryButtonOnClick}
            topButtonCaption={notNowButton}
            topButtonType={props.backUrl ? 'link' : 'button'}
            topButtonLink={props.backUrl}
            topButtonOnClick={props.topButtonOnClick}
            insideModalComponent
            insideStories
        />,
        <InfoPage
            key="step-4"
            iconName="3-thin"
            iconColor="primary"
            headerText={libreDisclaimerTitle3}
            secondaryText={<>{getTexts(libreDisclaimerText3)}</>}
            primaryButtonCaption={tryPaysendLibreButton}
            primaryButtonType="button"
            primaryButtonOnClick={props.primaryButtonOnClick}
            topButtonCaption={notNowButton}
            topButtonType={props.backUrl ? 'link' : 'button'}
            topButtonLink={props.backUrl}
            topButtonOnClick={props.topButtonOnClick}
            insideModalComponent
            insideStories
        />,
    ];

    return <Stories steps={steps} />;
};
export default BasePage(LibreDisclaimers);
